<a
  *ngIf="liveMode"
  [href]="whatsAppUrl"
  target="_blank"
  rel="noopener noreferrer"
  class="whatsapp-float"
>
  <img src="/images/whatsapp/whatsapp.gif" alt="WhatsApp" />
</a>
